import axios from "axios";
import qs from 'qs'
import common from '../comm'
import router from '../../../router/router.js'
import {
    Message
} from 'element-ui'
// import router from '../../router'
import {
    showLoading,
    hideLoading
} from '../common/loading'
import tools from '@/assets/js/tool'

const baseURL = common.baseURL; //服务器地址

axios.defaults.baseURL = `${baseURL}`;
axios.defaults.timeout = 1000000;

// axios.defaults.headers['ClientHost'] = tools.getDomainName();
axios.defaults.headers['LanguageCode'] = tools.getLanguageCode();
axios.defaults.headers['Device'] = 'admin_h5:app_status'; //应用标识
// axios.defaults.headers['Device'] = 'admin:app_status'; //应用标识

// path, params, method, headerType ,'是否显示加载中','是否提示报错信息'
function axios_requer(options) {
    let that = this;
    let {
        path,
        params = {},
        method = 'POST',
        headerType = '', //json 和 "" 两种
        isShowLoading = true,  //是否显示加载中
        istips = true,        //是否弹窗
        hasSing = false,      //是否有签名
    } = options

    let baseURL = baseURL;
    // 签名
    if (hasSing) {
        if (params.sign) {
            delete params.sign //有些接口重复多次调用会把sign也拿去加密多一次了
        }
        params.sign = tools.getSign(params)
    };


    //设置请求头
    if (method == 'POST') { //post请求
        if (headerType === "json") {
            axios.defaults.headers["Content-Type"] = 'application/json;charset=UTF-8'
        } else {
            axios.defaults.headers["Content-Type"] = 'application/x-www-form-urlencoded;charset=UTF-8'
            params = qs.stringify(params);
        }
    }

    let ClientHostName = tools.getDomainName() || '';
    let EnterpriseNo = tools.getEnterpriseNo() || '';
    ClientHostName = EnterpriseNo.length > 0 ? '' : ClientHostName
    axios.defaults.headers['ClientHost'] = ClientHostName
    axios.defaults.headers['EnterpriseNo'] = EnterpriseNo
    // if (!EnterpriseNo) {
    //     Message.closeAll()
    //     Message.error({
    //         message: '没有检测到企业编号',
    //         duration: 1800,
    //         showClose: true,
    //     })
    // }

    //get请求
    if (method == 'GET') {
        axios.defaults.headers["Content-Type"] = 'application/x-www-form-urlencoded;charset=UTF-8'
        let data = qs.stringify(params);
        if (data) {
            path = path + '?' + data
        }
    }
    if (isShowLoading) {
        showLoading()
    }

    // 请求拦截
    axios.interceptors.request.use((config) => {
        config.headers['UserKey'] = window.localStorage.UserKey || '';
        return config;
    }, (error) => {
        if (isShowLoading) {
            hideLoading();
        }

        return error;
    });

    //响应拦截
    axios.interceptors.response.use(response => {
        if (isShowLoading) {
            hideLoading();
        }
        return response;
    }, error => {
        if (isShowLoading) {
            hideLoading();
        }
        return error
    })

    //发送请求
    return new Promise((resolve, reject) => {
        axios({
            baseURL,
            method,
            url: path,
            data: params,
        }).then((result) => {
            if (result.data.status === 'error') {
                if (istips) {
                    Message.closeAll()
                    Message.error({
                        message: result.data.message || '',
                        duration: 1800,
                        showClose: true,
                    })
                }
                let jump = result.data.jump || '';
                if (jump) {
                    if (jump === 'login') {
                        router.push({
                            path: '/login'
                        })
                        window.localStorage.setItem('ifReLogin', true)
                        return
                    }
                    if (jump == 'apply') {
                        //没有权限
                        // router.replace('/login')
                    }
                    let reg = new RegExp(/http[s]{0,1}:\/\//);
                    let flag = reg.test(jump);
                    if (flag) {
                        window.location.href = jump
                    }
                }
                reject(result)
            } else {
                resolve(result)
                setTimeout(() => {
                    Message.closeAll()
                }, 1600);
            }

        }).catch(err => {
            reject(err)
        })
    })

}

// 文件上传
function axios_file(path, param, method_s) {
    axios.defaults.headers["Content-Type"] = 'multipart/form-data';
    axios.interceptors.request.use(function (config) {
        config.headers['UserKey'] = window.localStorage.UserKey;
        return config;
    }, function (error) {
        hideLoading();
        return error;
    });
    let method = method_s || 'POST';
    //发送请求
    return new Promise((resolve, reject) => {
        axios({
            baseURL,
            method,
            url: path,
            data: param,
        }).then(result => {

            if (result.data.status == 'error') {
                Message.error(result.data.message || '');
                let jump = result.data.jump || '';
                if (jump) {
                    if (jump == 'login') {
                        this.$router.push({
                            path: '/login'
                        })
                        window.localStorage.setItem('ifReLogin', true)
                        return
                    }
                    if (jump == 'apply') {
                        //没有权限
                        // uni.reLaunch({
                        // 	url: '/pages/login/login'
                        // })
                        // return
                    }
                    let reg = new RegExp(/http[s]{0,1}:\/\//);
                    let flag = reg.test(jump);
                    if (flag) {
                        window.location.href = jump
                    }

                }
            }
            resolve(result)
        }).catch(err => {
            reject(err)
        })
    })
}

// 导出文件流
function axios_export(options) {
    let that = this;
    let {
        path,
        params = {},
        method = 'POST',
        headerType = '', //json 和 "" 两种
        isShowLoading = true,  //是否显示加载中
        istips = true,        //是否弹窗
        hasSing = false,      //是否有签名
    } = options

    let baseURL = baseURL;
    // 签名
    if (hasSing) {
        if (params.sign) {
            delete params.sign //有些接口重复多次调用会把sign也拿去加密多一次了
        }
        params.sign = tools.getSign(params)
    };


    //设置请求头
    if (method == 'POST') { //post请求
        if (headerType === "json") {
            axios.defaults.headers["Content-Type"] = 'application/json;charset=UTF-8'
        } else {
            axios.defaults.headers["Content-Type"] = 'application/x-www-form-urlencoded;charset=UTF-8'
            params = qs.stringify(params);
        }
    }

    let ClientHostName = tools.getDomainName() || '';
    let EnterpriseNo = tools.getEnterpriseNo() || '';
    ClientHostName = EnterpriseNo.length > 0 ? '' : ClientHostName
    axios.defaults.headers['ClientHost'] = ClientHostName
    axios.defaults.headers['EnterpriseNo'] = EnterpriseNo

    //get请求
    if (method == 'GET') {
        axios.defaults.headers["Content-Type"] = 'application/x-www-form-urlencoded;charset=UTF-8'
        let data = qs.stringify(params);
        if (data) {
            path = path + '?' + data
        }
    }
    if (isShowLoading) {
        showLoading()
    }

    // 请求拦截
    axios.interceptors.request.use((config) => {
        config.headers['UserKey'] = window.localStorage.UserKey || '';
        return config;
    }, (error) => {
        if (isShowLoading) {
            hideLoading();
        }

        return error;
    });

    //响应拦截
    axios.interceptors.response.use(response => {
        if (isShowLoading) {
            hideLoading();
        }
        return response;
    }, error => {
        if (isShowLoading) {
            hideLoading();
        }
        return error
    })

    //发送请求
    return new Promise((resolve, reject) => {
        axios({
            baseURL,
            method,
            url: path,
            data: params,
            responseType: 'blob'  // 指定响应类型为二进制流，用于文件下载
        }).then((result) => {
            if (result.data.status === 'error') {
                if (istips) {
                    Message.closeAll()
                    Message.error({
                        message: result.data.message || '',
                        duration: 1800,
                        showClose: true,
                    })
                }
                let jump = result.data.jump || '';
                if (jump) {
                    if (jump === 'login') {
                        router.push({
                            path: '/login'
                        })
                        window.localStorage.setItem('ifReLogin', true)
                        return
                    }
                    if (jump == 'apply') {
                        //没有权限
                        // router.replace('/login')
                    }
                    let reg = new RegExp(/http[s]{0,1}:\/\//);
                    let flag = reg.test(jump);
                    if (flag) {
                        window.location.href = jump
                    }
                }
                reject(result)
            } else {
                resolve(result)
                setTimeout(() => {
                    Message.closeAll()
                }, 1600);
            }

        }).catch(err => {
            reject(err)
        })
    })

}

export {
    axios_requer,
    axios_file,
    axios_export,
}